import ReactGA from 'react-ga';

const start = () => ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);

export default { start, service: ReactGA };
